document.addEventListener('DOMContentLoaded', function() {
    // Handle multiple video blocks
    document.querySelectorAll('.open-video-btn').forEach(function(openBtn) {
        const blockId = openBtn.dataset.blockId;
        const drawer = document.querySelector(`.video-drawer[data-block-id="${blockId}"]`);
        const blurOverlay = document.querySelector(`.video-blur-overlay[data-block-id="${blockId}"]`);
        const fullVideo = document.querySelector(`.popup-video[data-block-id="${blockId}"]`);
        const closeBtn = document.querySelector(`.close-video-drawer[data-block-id="${blockId}"]`);

        if (!drawer || !blurOverlay || !fullVideo || !closeBtn) return;

        // Prevent iOS fullscreen
        fullVideo.setAttribute('playsinline', '');
        fullVideo.setAttribute('webkit-playsinline', '');

        // Prevent context menu on long press (iOS)
        fullVideo.addEventListener('contextmenu', function(e) {
            e.preventDefault();
            return false;
        });

        openBtn.addEventListener('click', function() {
            drawer.style.display = 'block';
            blurOverlay.style.display = 'block';
            fullVideo.currentTime = 0;
            fullVideo.play();

            // Force playsinline on iOS
            if (fullVideo.webkitEnterFullscreen) {
                fullVideo.removeAttribute('controls');
            }
        });

        closeBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            fullVideo.pause();
            drawer.style.display = 'none';
            blurOverlay.style.display = 'none';
        });

        blurOverlay.addEventListener('click', function() {
            fullVideo.pause();
            drawer.style.display = 'none';
            blurOverlay.style.display = 'none';
        });
    });
});
